<template>
  <div>
    <Form ref="formData" :model="formData" :rules="rules" style="padding: 5px">

      <!-- PIN -->
      <FormItem :label="pin_label" prop="programming_pin">
        <Input
          v-model="formData.programming_pin"
          :placeholder="pin_label"

          autocomplete="off"
        ></Input>
      </FormItem>


      <FormItem align="right">
        <Button
          type="success"
          @click="saveAction()"
          :disabled="disabledSaveButton"
        >Сохранить</Button
        >
        <!--<Button type="primary" @click="saveAction()" :disabled="!validForm">Сохранить</Button>-->
      </FormItem>
    </Form>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>



</template>

<script>
import { base_url } from "../../../http.js";

export default {
  name: "companyLKSettings",
  data() {
    return {
      loading: false,
      baseViewUrl: base_url + "/company/pin/",
      schema: {},
      rules: {},
      validForm: false,
      isChanged: false,
      formData: {
        programming_pin: "",
      },
      pin_label: 'PIN режима программирования кассы'
    };
  },

  computed: {
    disabledSaveButton() {
      return !this.isChanged || !this.formData.programming_pin;
    }
  },

  methods: {
    // fetchSchema() {
    //   this.$http
    //     .options(this.baseViewUrl)
    //     .then(response => {
    //       this.schema = response.data.actions.PUT;
    //       this.getRules();
    //     })
    //     .catch(error => {
    //       this.$Message.error("Ошибка получения схемы");
    //     });
    // },

    // fetchInitialData() {
    //   this.$http
    //     .get(this.baseViewUrl)
    //     .then(response => {
    //       this.formData = response.data;
    //
    //       for (let field in this.formData) {
    //         this.formData[field] = response.data[field];
    //       }
    //
    //       this.fetchSchema();
    //     })
    //     .catch(error => {
    //       this.$Message.error("Ошибка получения данных");
    //     })
    //     .then(() => {
    //       this.loading = false;
    //     });
    // },

    // getSchema(name) {
    //   return this.schema[name];
    // },

    validateForm() {
      this.$refs.formData.validate(valid => {
        this.validForm = valid;
      });
    },

    saveAction() {
        this.save();
    },

    save() {
      this.loading = true;
      this.$http
        .put(this.baseViewUrl, this.formData)
        .then(response => {
          this.$Message.success("Успешно сохранено");
          this.isChanged = false;
        })
        .catch(error => {
          this.$Notice.open({
                      title: 'Ошибка',
                      desc: 'Для редактирования PIN необходимо закрыть все смены на кассах организации'
          });
        })
        .then(() => {
          this.loading = false;
        });
    },

    // getRules() {
    //   for (let field in this.schema) {
    //     if (this.schema[field].required) {
    //       this.rules[field] = [
    //         {
    //           required: true,
    //           message: this.schema[field].help_text,
    //           trigger: "blur"
    //         }
    //       ];
    //
    //       // this.$watch('formData.' + field, function (newValue, oldValue) {
    //       //   this.validateForm();
    //       // });
    //     }
    //
    //     this.$watch("formData." + field, function(newValue, oldValue) {
    //       this.validateForm();
    //       this.isChanged = true;
    //     });
    //   }
    // }
  },
  watch: {
    'formData.programming_pin': function(){
      this.isChanged = true;
    }
  },
  created() {
    // this.fetchInitialData();
  }
};
</script>

<style scoped>
.demo-spin-container {
  display: inline-block;
  width: 200px;
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}
</style>



// WEBPACK FOOTER //
// src/integration/lkassa/company/companyLKSettings.vue